import React, { useContext, useEffect, useState } from "react";
import classes from "./UsersTable.module.scss";
import CheckIcon from '@mui/icons-material/Check';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LoadingDots from "../UI/LoadingDots";
import { DDD } from "../../lib/ddd/ddd";
import { OverlayTrigger,Tooltip } from "react-bootstrap";
import {  Dialog, DialogActions, DialogContent, DialogTitle,FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Button from "../UI/Button";
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from "react-i18next";
import { OrgIdContext, ClientTypes, CustomerRelations } from "../../store/orgId_context";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import HelpIcon from '@mui/icons-material/Help';
import { resetOwnPassword } from "../../lib/resetOwnPassword";
import { isOAuthAccount, isOwnUser } from "../../lib/accountSource";

const UsersTable = ({ usersData, refreshUsers, loading, removeUser:removeUserParent, testMode, canAddUser }) => {
  const [usersList, setUsersList] = useState(usersData);
  const {sessionInfo, isTrustee, isSuperUser, customerRelation, clientType,} = useContext(OrgIdContext)
  const [userToRemove, setUserToRemove] =  useState();
  const [confirmDialog, setConfirmDialog] = useState();
  const {t} = useTranslation();

  const onSearchUserHandler = (e) => {
    const searchHandle = e.target.value.toLowerCase();
    if (searchHandle) {
      const filteredUsers = usersData.filter(
        (user) =>
          user.Name.toLowerCase().includes(searchHandle) ||
          user.Lastname.toLowerCase().includes(searchHandle) ||
          user.Email.toLowerCase().includes(searchHandle)
      );
      setUsersList(filteredUsers);
    } else {
      setUsersList(usersData);
    }
  };
  useEffect(() => {
    setUsersList(usersData);
  }, [usersData]);

  const removeUser = (user) =>{
    setConfirmDialog(true);
    setUserToRemove(user);
  }

  const onCancelConfirm = () =>{
    setConfirmDialog(false);
    setUserToRemove(null);
  }

  const onConfirmUserRemove = () =>{
    setConfirmDialog(false);
    if(removeUserParent)
      removeUserParent(userToRemove?.Id);
    setUserToRemove(null);
  }

  return (
    <>
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      TransitionProps={{ }}
      open={confirmDialog}>
          <DialogTitle>{t("Confirm user removal")}</DialogTitle>
          <DialogContent dividers>
              {t("Are you certain you wish remove access")}: {userToRemove?.Name}
          </DialogContent>
          <DialogActions>
              <Button autoFocus onClick={onCancelConfirm}>
              {t("Cancel")}
              </Button>
              <Button onClick={onConfirmUserRemove}>Ok</Button>
          </DialogActions>
    </Dialog>

    <div className={classes.container}>
      <div className="d-flex justify-content-end">
        <input
          type="text"
          placeholder="Search user"
          onChange={onSearchUserHandler}
        />
        {testMode &&<Button style={{marginLeft:"1rem"}}>
          <OverlayTrigger placement="top" overlay={<Tooltip>Refresh</Tooltip>}>
            <RefreshIcon onClick={refreshUsers}/>
          </OverlayTrigger>
        </Button>}
      </div>
      {loading && <LoadingDots/>}
      {!loading && <>
      <div className={classes["table-wrapper"]}>
  <table className={classes["styled-table"]}>
    <thead>
      <tr>
        {testMode && <th>Id</th>}
        <th>{t("Name")}</th>
        <th>{t("Contact info")}</th>
        <th>Trustee
          <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={{ maxWidth: "400px", whiteSpace: "normal" }}>
                  <div style={{ textAlign: "left" }}>
                    <strong>Trustee</strong> – All access. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>} {canAddUser ? <>Can remove Users but not create them.</> : <>No user management.</>}<br />
                  </div>
                </Tooltip>
              }
            >
                <span
                style={{
                  marginLeft: 6,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",   // align vertically
                  verticalAlign: "middle" // nudge it in tables
                }}
              >
                <HelpIcon
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1rem",
                    color: "var(--main-blue)",
                    marginTop: "2px" // 👈 manual nudge down
                  }}
                />
              </span>
            </OverlayTrigger>
        </th>
        <th>Admin
          <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={{ maxWidth: "400px", whiteSpace: "normal" }}>
                  <div style={{ textAlign: "left" }}>
                    <strong>Admin</strong> – All access. Full user management control. {clientType === ClientTypes.ISV && <>Can be automatically copied to newly created clients (see AddCustomer).</>}
                  </div>
                </Tooltip>
              }
            >
                <span
                style={{
                  marginLeft: 6,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",   // align vertically
                  verticalAlign: "middle" // nudge it in tables
                }}
              >
                <HelpIcon
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "1rem",
                    color: "var(--main-blue)",
                    marginTop: "2px" // 👈 manual nudge down
                  }}
                />
              </span>
            </OverlayTrigger>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {usersList.map((user, index) => (
        <tr key={`team-member-${index}`}>
          {testMode && <td>{user.Id}</td>}
          <td>
            {user.Name}{` ${user.Lastname}`}
            {(!user.Active || !user.ActivePass || !user.OrgActive) && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {user.Active
                      ? user.ActivePass
                        ? t("Access denied")
                        : t("Credentials not confirmed")
                      : t("User not activated")}
                  </Tooltip>
                }
              >
                <WarningAmberIcon
                  className="ms-2"
                  style={{
                    color: "var(--main-orange)",
                    cursor: "default",
                  }}
                  fontSize="small"
                />
              </OverlayTrigger>
            )}
            {/* Own row only — and not when the row says IsOAuth, i.e. the account was
                created through Google. Those accounts have no password at all: Google
                handles sign-in, so there is nothing for the reset funnel to reset. */}
            {isOwnUser(user, sessionInfo?.User) && !isOAuthAccount(user) && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t("Reset your password")}</Tooltip>}
              >
                <VpnKeyIcon
                  className="ms-2"
                  style={{
                    color: "var(--main-blue)",
                    cursor: "pointer",
                  }}
                  fontSize="small"
                  onClick={() => resetOwnPassword(user.Email)}
                />
              </OverlayTrigger>
            )}
          </td>
          <td>{user.Email}</td>
          <td className={classes["center-cell"]}>
            {user.Trustee ? <CheckIcon /> : ""}
          </td>
          <td className={classes["center-cell"]}>
            {user.Admin ? <CheckIcon /> : ""}
          </td>
          <td className={`${classes["center-cell"]} ${classes["action-cell"]}`}>
            {!testMode && <>
              {(isSuperUser || (!user.Trustee && isTrustee)) && <OverlayTrigger
                placement="left"
                overlay={<Tooltip>{t("Remove access")}</Tooltip>}
              >
                <RemoveCircleOutlineIcon
                  className={classes["remove-btn"]}
                  onClick={() => removeUser(user)}
                />
              </OverlayTrigger>}
            </>}
            {testMode && (
              <OverlayTrigger
                placement="left"
                overlay={<Tooltip>{t("Remove access")}</Tooltip>}
              >
                <RemoveCircleOutlineIcon
                  className={classes["remove-btn"]}
                  onClick={() => removeUser(user)}
                />
              </OverlayTrigger>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

     </> }
    </div>
    </>);
};

export default UsersTable;
